<template>
    <v-card class="stt-player-btn theme-transparent" :class="teamMirror(team) ? 'order-normal' : 'order-reverse'" :disabled="gamefinished || isPlayerDisabled(player)" flat depressed tile large>
        <v-btn v-if="!started" @click="excludePlayer" :class="player.excluded ? 'theme-title' : 'theme-hightext'" class="stop-player-playing theme-border pa-0" depressed tile>
            <v-icon :class="player.excluded ? 'rotate-45' : ''">mdi-close</v-icon>
        </v-btn>
      <v-btn v-if="!started" @click="excludePlayer2" :class="player.excluded ? 'theme-title' : 'theme-hightext'" class="stop-player-playing theme-border pa-0" depressed tile>
        <v-icon :class="player.excluded ? 'rotate-45' : ''">mdi-book-clock-outline</v-icon>
      </v-btn>
        <v-card :disabled="gamefinished || player.excluded" flat tile class="player-inner theme-transparent theme-border d-inline-flex align-center" @click="clickPlayer" :class="teamMirror(team) ? 'text-right' : 'text-left flex-row-reverse'">
            <v-tooltip top v-if="typeof playtime[player.id] !== 'undefined' && playtime[player.id].elapsed > 0">
                <template v-slot:activator="{on}">
                    <v-card flat tile class="text-no-wrap stt-player-name transparent playtime" v-on="on">{{ getPlayerPlaytime(player.id) }}</v-card>
                </template>
                <span>Pályán töltött idő</span>
            </v-tooltip>
            <v-card flat tile class="flex-grow-1 stt-player-name text-truncate transparent">{{ player.name }}</v-card>
            <v-card flat tile class="stt-player-number mr-2 ml-2 text-no-wrap transparent" v-if="player.jersey">{{ player.jersey }}</v-card>
        </v-card>
        <v-icon v-if="player.playing && !player.excluded" class="player-playing theme-transparent theme-border">mdi-soccer</v-icon>
        <v-card v-if="player.excluded" tile flat class="player-playing player-excluded theme-border theme-title">{{player.remainingExclude}}</v-card>
    </v-card>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from '@/constants';
    import TimeFormatter from "@/TimeFormatter";

    export default {
        name: 'PlayerSubstitute',
        props: {
            team: String,
            player: Object,
            started: Boolean,
            isMirrored: Boolean,
            gamefinished: Boolean,
            playtime: Object
        },
        methods: {
            isPlayerDisabled(person) {
                if (!person) {
                    return false;
                }

                if(typeof person.disabled === "boolean") {
                    return person.disabled;
                }

                if(typeof person.disabled === "object") {
                    let ret = false;

                    for (let disabled of Object.values(person.disabled)) {
                        ret |= disabled;
                    }

                    return !!ret;
                }
            },
            teamMirror: function(teamChar) {
                if(!this.isMirrored) {
                    return (teamChar === "A");
                } else {
                    return (teamChar !== "A");
                }
            },
            clickPlayer: function() {
                if(this.started) {
                    this.playerPlay();
                } else {
                    this.playerSelect();
                }
            },
            playerPlay: function() {
                eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.PLAY, !this.player.playing, this.player, this.team);
            },
            playerSelect: function() {
                eventBus.$emit(CONSTANTS.ACTIONS.TOGGLE.PLAYER.SELECT, !this.player.selected, this.player, this.team);
            },
            excludePlayer: function() {
                if(this.player.excluded || this.player.playing) {
                    eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYER, !this.player.excluded, this.player, this.team, null);
                } else {
                    eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, this.player, this.team);
                }
            },
          excludePlayer2: function() {
            if(this.player.excluded || this.player.playing) {
              eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYER, !this.player.excluded, this.player, this.team, null,2);
            } else {
              eventBus.$emit(CONSTANTS.ACTIONS.EXCLUDEPLAYERDIALOG, this.player, this.team);
            }
          },
            getPlayerPlaytime: function(player_id) {
                if(typeof this.playtime[player_id] !== "undefined" && this.playtime[player_id].elapsed > 0) {
                    return TimeFormatter.intToString(this.playtime[player_id].elapsed);
                }

                return '';
            }
        },
    }
</script>

<style scoped>
    .v-card.stt-player-btn {
        height: 100%;
        width: 100%;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 100%;

        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
    }

    .v-card.stt-player-btn.order-normal {
        flex-flow: row;
        flex-direction: row;
    }

    .v-card.stt-player-btn.order-normal .player-inner {
        padding-left: 8px;
    }

    .v-card.stt-player-btn.order-reverse {
        flex-flow: row-reverse;
        flex-direction: row-reverse;
    }

    .v-card.stt-player-btn.order-reverse .player-inner {
        padding-right: 8px;
    }

    .v-card.stt-player-number {
        font-size: 16px;
        font-weight: 900;
        letter-spacing: -0.5px;
        min-width: 20px;
        text-align: right;
    }

    .v-card.stt-player-name {
        font-size: 12px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .v-card.stt-player-btn.order-normal .player-inner {
        border-left-width: 0;
        border-right-width: 1px;
    }

    .v-card.stt-player-btn.order-reverse .player-inner {
        border-left-width: 1px;
        border-right-width: 0;
    }

    .player-inner {
        width: calc(100% - 45px);
        border-style: solid;
        border-top-width: 0;
        border-bottom-width: 1px;
        height: 100%;
    }

    .player-inner:first-child {
        width: 100%;
    }

    .stop-player-playing {
        min-width: 45px !important;
        height: 100% !important;
        cursor: pointer;
        border-style: solid;
        border-top-width: 0;
        border-left-width: 1px;
        border-right-width: 1px;
        border-bottom-width: 1px;
    }

    .v-card.stt-player-btn.order-normal .player-playing {
        border-left-width: 0;
        border-right-width: 1px;
    }

    .v-card.stt-player-btn.order-reverse .player-playing {
        border-left-width: 1px;
        border-right-width: 0;
    }

    .player-playing {
        min-width: 45px;
        width: 45px;
        height: 100%;
        cursor: pointer;
        border-style: solid;
        border-top-width: 0;
        border-bottom-width: 1px;
    }

    .player-excluded {
        color: #ffffff !important;
        background-color: #F73051 !important;
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        font-size: 12px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        transition: all 300ms;
    }

    .rotate-45 {
        transform: rotate(45deg);
    }

    .playing.goalkeeper-player:not(.excluded) .stt-player-number {
        color: #5687FF !important;
    }

    .playing.goalkeeper-player:not(.excluded) .player-playing {
        color: #5687FF !important;
    }

    .playing.goalkeeper-player:not(.excluded) .stt-player-name {
        color: #5687FF !important;
    }

    .excluded .stt-player-number {
        color: #F73051 !important;
    }

    .playing.normal-player:not(.excluded) .stt-player-number {
        color: #23C373 !important;
    }

    .playing.normal-player .player-playing:not(.player-excluded) {
        color: #23C373 !important;
    }

    .theme--dark.v-icon.stop-player-playing.v-icon--disabled {
        color: #4d5269 !important;
    }

    .theme--light.v-icon.stop-player-playing.v-icon--disabled {
        color: #aaaaaa !important;
    }

    .playtime {
        min-width: 30px;
    }

    .v-card.stt-player-btn.order-normal .playtime {
        text-align: left;
    }

    .v-card.stt-player-btn.order-reverse .playtime {
        text-align: right;
    }
</style>

<style>
    .v-list-item.playing .player-inner {
        max-width: calc(100% - 90px);
    }

    .v-list-item.playing .player-inner:first-child {
        max-width: calc(100% - 45px);
    }

    .v-list-item.excluded .player-inner {
        max-width: calc(100% - 90px);
    }

    .v-list-item.excluded .player-inner:first-child {
        max-width: calc(100% - 45px);
    }

    .v-list-item.goalkeeper-player:not(.playing):not(.excluded) + .v-list-item.goalkeeper-player.playing .player-playing {
        border-top-width: 1px;
    }

    .v-list-item.normal-player:not(.playing):not(.excluded) + .v-list-item.normal-player.playing .player-playing {
        border-top-width: 1px;
    }

    .v-list-item.goalkeeper-player + .v-list-item.normal-player .player-inner {
        border-top-width: 1px;
    }

    .v-list-item.goalkeeper-player + .v-list-item.normal-player .stop-player-playing {
        border-top-width: 1px;
    }

    .v-list-item.goalkeeper-player + .v-list-item.normal-player .player-playing {
        border-top-width: 1px;
    }

    .v-list-item:first-child .player-inner {
        border-top-width: 0;
    }

    .v-list-item:first-child .stop-player-playing {
        border-top-width: 0;
    }

    .v-list-item:first-child .player-playing {
        border-top-width: 0;
    }
</style>
